import { Route } from 'react-router-dom';
import Customers from '../Pages/Customers/Customers';
import Layout from '../components/layout';
import EditCustomer from '../Pages/Customers/EditCustomer';
import ProtectedRoute from '../components/ProtectedRoute';

export const CustomerRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/customers" element={
      <ProtectedRoute>
        <Layout activePage='customers' menuActive={menuActive} setMenuActive={setMenuActive}>
          <Customers />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/customer/:customerId" element={
      <ProtectedRoute>
        <Layout activePage='edit-customer' menuActive={menuActive} setMenuActive={setMenuActive}>
          <EditCustomer />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);
